import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-ext";
var NumberInput = /** @class */ (function (_super) {
    tslib_1.__extends(NumberInput, _super);
    function NumberInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.valueWasChanged = false;
        _this.inputValue = _this.value;
        _this.hasFocus = false;
        _this.keyUpTimer = null;
        return _this;
    }
    NumberInput.prototype.created = function () {
        var _this = this;
        this.$watch("value", function (v) { return _this.inputValue = v; });
        if (isNaN(this.inputValue)) {
            this.inputValue = null;
        }
        //this.$watch("inputValue", this.inputChanged);
        // this.$watch("min", this.inputChanged);
        // this.$watch("max", this.inputChanged);
    };
    NumberInput.prototype.focus = function () {
        this.hasFocus = true;
        this.$emit('focus');
    };
    NumberInput.prototype.keydown = function (event) {
        if (event.key.length == 1 && isNaN(event.key)) {
            event.preventDefault();
            return;
        }
        clearTimeout(this.keyUpTimer);
        var self = this;
        this.keyUpTimer = setTimeout(function () { return self.ensureValue(); }, 2000);
    };
    NumberInput.prototype.blur = function () {
        this.hasFocus = false;
        this.ensureValue();
        this.$emit('blur');
    };
    Object.defineProperty(NumberInput.prototype, "inputClasses", {
        get: function () {
            var classes = [];
            var paramClasses = this.classes || [];
            if (this.hasFocus)
                classes.push("focus");
            return tslib_1.__spread(classes, paramClasses);
        },
        enumerable: true,
        configurable: true
    });
    NumberInput.prototype.ensureValue = function () {
        var _this = this;
        if (!this.inputValue || this.inputValue.toString() == "") {
            //this.$emit("input", null);
            // Vue.nextTick(() => {
            //     this.inputValue = null;
            // });
            return;
        }
        var self = this;
        var value = this.getValidValue(this.inputValue, true, true);
        var valueChanged = value !== this.inputValue;
        if (valueChanged) {
            self.valueWasChanged = true;
            setTimeout(function () {
                self.valueWasChanged = false;
            }, 4000);
        }
        this.$emit("input", value);
        Vue.nextTick(function () {
            _this.$state.dirty = true;
            _this.inputValue = _this.value;
        });
    };
    NumberInput.prototype.getValidValue = function (newValue, validateMin, validateMax) {
        var step = this.step || 1;
        var number = Math.ceil(Number(newValue) / step) * step;
        if (this.max && number > this.max && validateMax)
            return this.max;
        if (newValue == "" && this.min < 0 && validateMin)
            return newValue;
        if (number <= this.min && validateMin)
            return this.min;
        return number;
    };
    tslib_1.__decorate([
        Prop({ type: String, default: "" }),
        tslib_1.__metadata("design:type", String)
    ], NumberInput.prototype, "resourceKey", void 0);
    tslib_1.__decorate([
        Prop({ type: [Array, String], default: "" }),
        tslib_1.__metadata("design:type", Object)
    ], NumberInput.prototype, "classes", void 0);
    tslib_1.__decorate([
        Prop({ type: Number, default: null }),
        tslib_1.__metadata("design:type", Number)
    ], NumberInput.prototype, "value", void 0);
    tslib_1.__decorate([
        Prop({ type: Number, default: null }),
        tslib_1.__metadata("design:type", Number)
    ], NumberInput.prototype, "step", void 0);
    tslib_1.__decorate([
        Prop({ type: Number, default: null }),
        tslib_1.__metadata("design:type", Number)
    ], NumberInput.prototype, "max", void 0);
    tslib_1.__decorate([
        Prop({ type: Number, default: 0 }),
        tslib_1.__metadata("design:type", Number)
    ], NumberInput.prototype, "min", void 0);
    tslib_1.__decorate([
        Prop({ type: Boolean, default: false }),
        tslib_1.__metadata("design:type", Boolean)
    ], NumberInput.prototype, "disabled", void 0);
    NumberInput = tslib_1.__decorate([
        Component
    ], NumberInput);
    return NumberInput;
}(Vue));
export default NumberInput;
